define(
    [
        'text!edge/quoteandbind/common/views/base-qnb-wizard.html',
        'text!edge/quoteandbind/common/views/qnb.html',
        'text!edge/quoteandbind/common/views/quote-details.html',
        'text!edge/quoteandbind/common/views/payment-details.html',
        'text!edge/quoteandbind/common/views/contact-us.html',
        'text!edge/quoteandbind/common/views/confirmation.html',
        'text!edge/quoteandbind/baslercommon/views/basler-initial.html',
        'text!edge/quoteandbind/common/views/faq-page.html',

        'edge/quoteandbind/common/controllers/QuoteEntryCtrl',
        'edge/quoteandbind/common/controllers/BaseQnbWizardCtrl',
        'edge/quoteandbind/common/controllers/QuoteDetailsCtrl',
        'edge/quoteandbind/common/controllers/PaymentDetailsCtrl',
        'edge/quoteandbind/common/controllers/ContactUsCtrl',
        'edge/quoteandbind/common/controllers/ConfirmationCtrl',
        'edge/quoteandbind/baslercommon/controllers/BaslerInitialCtrl'],
    (
        BaseQnbWizardView, QuoteAndBindApplicationView, QuoteDetailsView, PaymentDetailsView, ContactUsView, ConfirmationView, BaslerInitialView, FaqPageView,
        QuoteEntryCtrl, BaseQnbWizardCtrl, QuoteDetailsCtrl, PaymentDetailsCtrl, ContactUsCtrl, ConfirmationCtrl, BaslerInitialCtrl
    ) => {
        return (RootStates) => {

            const wizardParentState = 'baseQnbWizard';

            const parentState = RootStates.quote_bind;

            return {

                home: {
                    parent: parentState,
                    url: '/home?postalCode&quoteID&vehicleType&locale&product&channel&subproductInputParam&retrievedByLink&empMode&advisorNumber&firstRegistrationYear&firstRegistrationMonth&uniqueVehicleIdentifier&birthDate&nationality&enableLogging&producerForCommissionSplit',
                    params: {
                        quoteID: null, //provided when resuming a draft submission
                        vehicleType: null, //auto or motorcycle
                        retrievedByLink: null, //indicator if submission is retrievedByLink
                        locale: null, // locale
                        channel: null, // channel (for example TCS)
                        empMode: 'false',
                        advisorNumber: null,
                        firstRegistrationYear: null,
                        firstRegistrationMonth: null,
                        uniqueVehicleIdentifier: null,
                        birthDate: null,
                        nationality: null,
                        postalCode: null,
                        enableLogging: 'true',
                        producerForCommissionSplit: null,
                    },
                    controller: BaslerInitialCtrl,
                    template: BaslerInitialView,
                    data: {
                        trackingUrl: '',
                    },
                },
                quoteentry: {
                    parent: parentState,
                    url: '/quoteentry&vehicleType&channel&retrievedByLink',
                    controller: QuoteEntryCtrl,
                    params: {
                        quoteID: null, //provided when resuming a draft submission
                        retrievedByLink: null, //indicator if submission is retrievedByLink
                        postalCode: null, //provided when resuming or starting a submission
                        productCode: null, //provided when starting a submission
                        subproductInputParam: null, //provided when starting a submission
                        effectiveDate: null, //provided when startiKng a submission
                        agentportalnewsubmission: null, //provided when starting a quote from gpa,
                        account: null, // provided when starting a quote from amp
                        shouldUpdateEffectiveDate: null, // provided when starting a quote from qnb
                        vehicleType: null, // vehicle type if we want to restrict to some of them
                        channel: null, // channel (for example TCS)
                        empMode: 'false',
                        advisorNumber: null,
                        firstRegistrationYear: null,
                        firstRegistrationMonth: null,
                        uniqueVehicleIdentifier: null,
                        birthDate: null,
                        nationality: null,
                        producerForCommissionSplit: null,
                    },
                    resolve: {
                        originState: ['$state', ($state) => {
                            //remember the state we came from so we can return if there is an error loading the claim
                            return {name: $state.current, params: $state.params};
                        }],
                    },
                    data: {
                        trackingUrl: () => {
                            return '';
                        },
                    },
                },
                baseQnbWizard: {
                    parent: parentState,
                    url: '/qnb-flow',
                    controller: BaseQnbWizardCtrl,
                    template: BaseQnbWizardView,
                    resolve: {
                        submissionViewModel: ['StateUtils', (StateUtils) => {
                            return () => StateUtils.dataForState(wizardParentState).model;
                        }],
                    },
                    data: {
                        trackingUrl: () => {
                            return '';
                        },
                    },
                },
                contactUs: {
                    name: 'contactUs',
                    url: '/contactus',
                    parent: parentState,
                    controller: ContactUsCtrl,
                    template: ContactUsView,
                    params: {
                        returnStateInfo: null,
                        quoteID: null,
                    },
                    data: {
                        trackingUrl: '^',
                    },
                },
            };
        };
    }
    );



// WEBPACK FOOTER //
// ./app/customer/js/src/edge/quoteandbind/common/config/RouteConfig.js